module.exports = __webpack_public_path__ + "img/SunleiGraduate.81f5e0e0.png";